$(document).ready(function () {
    var ckbox = $('#cits_vards');

    $('input').on('click',function () {
        if (ckbox.is(':checked')) {
            $('.custom_name_input_wrapper').fadeIn();
          $('#pieejamie-vardi').hide();
          $("#option-pieejamie-vardi").val("");

          
        } else {
           $('.custom_name_input_wrapper').hide();
        $('#pieejamie-vardi').fadeIn();
            $("#ievadiet-velamo-vardu").val("");
        }
    });
});